import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckSquare, faImage, faMapMarker } from "@fortawesome/free-solid-svg-icons";
import filterTypes from "data/filter-types";
import { closeCustomModal, openCustomModal } from "views/lib/components/modals";
import { search, finish } from "actions/scooter/trip-active/actions";
import MapPosition from "../trip-active/map-position";
import FinishTripModal from "../scooter/trip-active/finish-trip-modal";
import getFilesUrl from "../../../helpers/getFilesUrl";

const UserScooterTripActive = ({
                                 userId,
                                 list,
                                 search,
                                 finish,
                                 ...rest
                               }) => {
  const handleOpenMap = (position) => {
    if (!position || !Object.keys(position).length) {
      toast("Coordinates not available", {
        type: toast.TYPE.ERROR,
      });
      return null;
    }
    const modalObj = {
      id: "trip-active-position",
      modalSettings: {
        size: "sm"
      },
      header: "Trip position",
      children: (
        <MapPosition
          coordinates={[position.longitude, position.latitude]}
          onCancel={() => rest.closeCustomModal(modalObj)}
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCC-gpzzG6hcmAyagvaYCc23KAy4rIkv2A&v=3.exp&libraries=geometry,drawing,places,visualization"
          loadingElement={<div style={{ height: "100%" }}/>}
          containerElement={<div style={{ height: 400 }}/>}
          mapElement={<div style={{ height: "100%" }}/>}
        />
      ),
      handleClose: () => rest.closeCustomModal(modalObj)
    };
    rest.openCustomModal(modalObj);
  };

  const handleFinish = (id) => {
    const modalObj = {
      id: "trip-finish-modal",
      modalSettings: {
        size: "sm"
      },
      header: "Finish Trip",
      children: (
        <FinishTripModal
          id={id}
          callback={() => {
            rest.closeCustomModal(modalObj);
          }}
          onCancel={() => rest.closeCustomModal(modalObj)}
        />
      ),
      handleClose: () => rest.closeCustomModal(modalObj)
    };
    rest.openCustomModal(modalObj);
  };

  useEffect(() => {
    search(0, 1000, "start,DESC", [{
      fieldName: "user",
      fieldValue: userId,
      searchOperation: filterTypes.EQUALS.value
    }]);
  }, [search, userId]);

  return (
    <div>
      <table className="table table-hover table-bordered table-striped table-align-middle table-sm mb-0">
        <thead>
        <tr>
          <th>ID</th>
          <th>Scooter</th>
          <th>Scan</th>
          <th>Start (Position)</th>
          <th>End (Position)</th>
          <th>Distance</th>
          <th>Amount</th>
          <th>State</th>
          <th>Actions</th>
        </tr>
        </thead>
        <tbody>
        {((list && list.content) || []).map(item => (
          <tr key={item.id}>
            <td>
              <Link to={`/scooter/trip-active/${item.id}`}>
                {item.id}
              </Link>
            </td>
            <td>
              <Link to={`/scooter/scooter/${item.scooter}`}>
                {item.scooterQr || item.scooter}
              </Link>
            </td>
            <td>
              {moment(item.scan)
                .format("HH:mm YYYY-MM-DD")}
            </td>
            <td>
              {moment(item.start)
                .format("HH:mm YYYY-MM-DD")}{" "}
              <button
                className="btn btn-sm btn-primary"
                onClick={() => handleOpenMap(item.startPosition)}
                title="Start position"
              >
                <FontAwesomeIcon icon={faMapMarker}/>
              </button>
            </td>
            <td>
              {item.end ? (
                <React.Fragment>
                  {moment(item.end)
                    .format("HH:mm YYYY-MM-DD")}{" "}
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={() => handleOpenMap(item.endPosition)}
                    title="End position"
                  >
                    <FontAwesomeIcon icon={faMapMarker}/>
                  </button>
                </React.Fragment>
              ) : "No Date"}
            </td>
            <td>{item.distance}</td>
            <td>{item.amount}</td>
            <td>{item.state}</td>
            <td>
              <div className="btn-group">
                <a
                  className={`btn btn-sm ${item.photo ? "btn-primary" : "btn-secondary"}`}
                  title="Image"
                  href={item.photo ? getFilesUrl(item.photo) : ""}
                  target="_blank"
                  rel="noreferrer noopener"
                  onClick={ev => {
                    if (!item.photo) ev.preventDefault();
                  }}
                >
                  <FontAwesomeIcon icon={faImage}/>
                </a>
                <button
                  className="btn btn-sm btn-warning"
                  title="Finish"
                  onClick={() => handleFinish(item.id)}
                >
                  <FontAwesomeIcon icon={faCheckSquare}/>
                </button>
              </div>
            </td>
          </tr>
        ))}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = state => ({
  list: state.scooterTripActive.list,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  search: bindActionCreators(search, dispatch),
  finish: bindActionCreators(finish, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(UserScooterTripActive);



// WEBPACK FOOTER //
// ./src/views/pages/users/user-scooter-trip-active.js